import Seo from "../../components/Seo/Seo";

export default function OrgStructure() {
  return (
    <section className="page">
      <Seo title="الهيكل التنظيمي" />
      <div className="container">
        <h1>الهيكل التنظيمي</h1>
        <p className="muted">سيتم إضافة المخطط التنظيمي لاحقًا.</p>
      </div>
    </section>
  );
}
